function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "c-warning");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Version-2.1---User-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wizard---404-Error",
  transform: "translate(-426.000000, -440.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(203.000000, 442.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "c-warning",
  transform: "translate(225.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  cx: 88,
  cy: 88,
  r: 88
}), /*#__PURE__*/React.createElement("line", {
  x1: 88,
  y1: 33.3793103,
  x2: 88,
  y2: 109.241379,
  id: "Path",
  stroke: "#FFFFFF",
  strokeWidth: 3,
  fill: "#00AEFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 88,
  cy: 133.517241,
  r: 3.03448276
})))));

var SvgNotFound = function SvgNotFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "180px",
    height: "180px",
    viewBox: "0 0 180 180",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notFound.82fbac76.svg";
export { ForwardRef as ReactComponent };